module.exports = __webpack_public_path__ + "img/cloud_security.e6d4b661.jpeg";